<template>
    <div class="dialogouter" v-show="($parent.dialog_message != undefined)">

        <div class="dialog" style="display:flex;flex-direction: column;">
            <div>{{ $parent.dialog_message }}</div>
            <div><button @click="close_diag()">close</button></div>
        </div>
    </div>
</template>

<script>

import ENUMS from '../Enums';

export default {
    name: 'CoalDialog'
    , data() {
        return {
            ENUMS: ENUMS
            // , nft: undefined
            , new_price: undefined
            , new_onsale: 1
            , new_saleend: -1.0
            , in_loading: false
            , is_closed: true
        }
    }
    , props: []
    , mounted() {
        this.new_price = undefined
    }
    , computed: {

    }, components: {}
    , methods: {
        close_diag: function () {
            this.$parent.dialog_message = undefined
        }
    }
}

</script>

<style scoped>
.dialog {
    border-width: 4px;
    min-width: 200px;
    border-color: white;
    border-style: solid;
    background-color: black;
    padding: 5%;
    margin: 15%;
    margin-top: 30%;
    margin-left: 30%;
    margin-right: 30%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 50px;
}

.dialogouter {
    position: fixed;
    top: 0%;
    left: 0%;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.5);
    /* padding: 25%; */
    z-index: 400;
}
</style>